import React from 'react';
import { Link } from 'react-router-dom';

const SocialMediaMarketing = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-3xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <h1 className="text-4xl font-bold text-brand-blue mb-6 text-center">Social Media Marketing</h1>
      <p className="text-lg text-gray-700 mb-6 text-center">
        Build your brand and engage your audience with our creative social media marketing solutions. We help you grow your presence and foster loyal communities across all major platforms.
      </p>
      <ul className="list-disc pl-6 space-y-3 text-gray-800 mb-8">
        <li>Custom content creation for Facebook, Instagram, LinkedIn, and more</li>
        <li>Community management and engagement</li>
        <li>Paid social ad campaigns</li>
        <li>Influencer partnerships and outreach</li>
        <li>Social analytics and growth tracking</li>
      </ul>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default SocialMediaMarketing; 